export default __webpack_public_path__ + "static/media/INJ.e297d39c.png";